import React, { memo } from 'react';

interface ButtonProps {
    label: string;
    onClick: () => void;
    addedClass?: string;
}

const Button: React.FC<ButtonProps> = ({ label, onClick, addedClass }) => {
    return (
        <button
            onClick={onClick}
            className={`inline-block px-5 py-[10px] bg-custom-dark hover:bg-custom-orange text-white border-none rounded cursor-pointer no-underline ${addedClass}`}
        >
            {label}
        </button>
    );
};

export default memo(Button);